import React from 'react';

import ModalComponent from '@mlb/react-patterns/components/AnimatedModal/animatedModal.tsx';

import {
    Queries,
    Mutations,
    ApolloLib,
} from 'bdvp-graphql';

const { useQuery, useMutation } = ApolloLib;
const { GET_MODALS } = Queries;
const { MODAL_HIDE } = Mutations;

const Modal = ({
    name,
    isOpen,
    handlers = {},
    closeButtonRight = true,
    ...props
}) => {

    const { data } = useQuery(GET_MODALS);
    const modals = data ? JSON.parse(data.modals) : {};
    const [modalHide] = useMutation(MODAL_HIDE);
    const handlersOverride = {
        ...handlers,
        onClosed: (e) => {

            modalHide({
                variables: {
                    name,
                },
            });

            if (handlers.onClosed) handlers.onClosed(e);

        },
    };

    return (
        <ModalComponent
            open={isOpen || modals[name]}
            handlers={handlersOverride}
            closeButtonRight={closeButtonRight}
            {...props}
        />
    );

};

export default Modal;
